import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center w-full my-3 space-x-2" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex items-center space-x-1" }
const _hoisted_4 = { class: "mr-2 font-medium capitalize" }
const _hoisted_5 = { class: "flex w-full items-center" }
const _hoisted_6 = { class: "break-normal" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-muted" }, "delete", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      class: "my-auto",
      user: _ctx.user
    }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user.full_name ?? ""), 1),
        _createVNode(_component_Timestamp, {
          value: _ctx.created,
          reduced: true,
          class: "text-muted text-xs opacity-90"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    (_ctx.canDelete)
      ? (_openBlock(), _createBlock(_component_Btn, {
          key: 0,
          variant: 'icon',
          outline: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deleteMessage'))),
          class: "ml-auto opacity-30 hover:opacity-100 transition-opacity duration-75 ease-in-out"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}